import type { Playbook } from '@squadlab/contracts';

/**
 * Onboarding playbook v1 (ADR 0052 — SOPs are content, not code).
 *
 * The runner executes these steps generically: the agent drafts the pack, the
 * policy engine checks the probation window, a human approves at the gate,
 * and the record-update closes the loop. A revised SOP ships as version 2
 * ALONGSIDE this one — cases pin the version they ran.
 */
export const ONBOARDING_PLAYBOOK: Playbook = {
  key: 'onboarding',
  version: 1,
  function: 'onboarding',
  title: 'Employee onboarding',
  steps: [
    {
      id: 'draft-pack',
      kind: 'agent-draft',
      title: 'Draft the onboarding pack',
      instruction:
        'Author the contract/GOSI/Qiwa registration checklist, access provisioning and probation plan for the new joiner.',
    },
    {
      id: 'check-probation',
      kind: 'policy-check',
      title: 'Check the probation window (art. 53)',
    },
    {
      id: 'gate-review',
      kind: 'human-gate',
      title: 'Operator review of the onboarding pack',
      instruction: 'Approve to activate onboarding, request a redo of the pack, or reject the case.',
    },
    {
      id: 'record-activate',
      kind: 'record-update',
      title: 'Mark onboarding active on the employee record',
    },
  ],
};
